import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import RefundPolicy from './pages/RefundPolicy';
import { SITE_DOMAIN, SITE_NAME } from './constants/site';

const PAGE_TITLES = {
  '/': `${SITE_NAME} Support | ${SITE_DOMAIN}`,
  '/about': `About Us | ${SITE_DOMAIN}`,
  '/privacy-policy': `Privacy Policy | ${SITE_DOMAIN}`,
  '/terms-of-service': `Terms of Service | ${SITE_DOMAIN}`,
  '/refund-policy': `Refund Policy | ${SITE_DOMAIN}`,
};

function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = PAGE_TITLES[pathname] || PAGE_TITLES['/'];
  }, [pathname]);

  return null;
}

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <DocumentTitle />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
